

























import Vue from 'vue';
import { ZenEllipsis } from 'zenComponents';

/**
 * TODO: Remove this presenter and use the identical Object cell presenter for
 *       RelatedObjects attribute. This should be done after changes to the GQL
 *       schema allow for changes to cell and filter presenters to rely on the
 *       attribute type and not the attribute name.
 */

// TODO: should we instead handle list as separate presenter?
export default Vue.extend({
  name: 'RelatedObjectsCellPresenter',
  components: {
    ZenEllipsis,
  },
  computed: {
    objects() {
      if (!this.$attrs.data || !this.$attrs.data.value) {
        return [];
      }

      return this.$attrs.data.value['edges'] ? this.$attrs.data.value.edges : [{ node: this.$attrs.data.value }];
    },
  },
});
